import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-accordion", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("accordion", "multiple-accordions"),
            componentTag: "ux-accordion",
            pageHeight: 450,
            pageWidth: 450,
            performActions: async (page) => {
                await page.click(".ux-accordion [slot='title']");
                // fixes clickabla element moving as fouc
                try {
                    await page.waitForSelector(
                        "[slot='title'].ux-text-link--green",
                        { timeout: 1000 }
                    );
                } catch {
                    await page.click(".ux-accordion [slot='title']");
                }
                await page.waitForTimeout(1000);
            },
        });
    });
});
